import StreamingBuying from "./StreamingBuying";

export default StreamingBuying;
